import { useBreakpoints as useBreakpointsInternal } from './BreakpointsProvider';

export function useBreakpoints() {
  const breakpoints = useBreakpointsInternal();
  return breakpoints as {
    isNarrow: boolean;
    isExtraNarrow: boolean;
  };
}
